class AgeVerificationGate extends HTMLElement {
  connectedCallback() {
    this.cookieName = this.dataset.cookieName || 'age_verified';
    this.cookieDays = parseInt(this.dataset.cookieDays, 10) || 30;
    this.denyUrl = this.dataset.denyUrl || 'https://www.google.com';

    if (this.isVerified()) {
      this.remove();
      return;
    }

    this.setAttribute('open', '');
    document.documentElement.classList.add('age-verification-gate-open');

    this.confirmButton = this.querySelector('.age-verification-gate__confirm');
    this.denyButton = this.querySelector('.age-verification-gate__deny');

    this.confirmButton?.addEventListener('click', this.onConfirm.bind(this));
    this.denyButton?.addEventListener('click', this.onDeny.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

    this.confirmButton?.focus();
  }

  isVerified() {
    return document.cookie.split('; ').some((row) => row === `${this.cookieName}=true`);
  }

  setVerified() {
    const expires = new Date(Date.now() + this.cookieDays * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${this.cookieName}=true; expires=${expires}; path=/; SameSite=Lax`;
  }

  onConfirm() {
    this.setVerified();
    document.documentElement.classList.remove('age-verification-gate-open');
    this.remove();
  }

  onDeny() {
    window.location.href = this.denyUrl;
  }

  onKeydown(event) {
    if (event.key !== 'Tab') return;

    const focusable = this.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

customElements.define('age-verification-gate', AgeVerificationGate);
